export default function Button({ children, variant = 'primary', size = 'md', className = '', ...props }) {
  const base = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-[#06b6d4] text-[#060a10] hover:bg-[#0ea5c7]',
    secondary: 'bg-transparent border border-[rgba(148,163,184,0.10)] text-[#94a3b8] hover:border-[#06b6d4] hover:text-[#06b6d4]',
    danger: 'bg-red-600 text-white hover:bg-red-700',
    ghost: 'text-[#64748b] hover:bg-[rgba(148,163,184,0.04)] hover:text-[#94a3b8]',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-[12px]',
    md: 'px-4 py-2 text-[12.5px]',
    lg: 'px-6 py-3 text-[13px]',
  };

  return (
    <button className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} {...props}>
      {children}
    </button>
  );
}
